import React from 'react'
import styled from '@emotion/styled'
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import { ClassNames } from '@emotion/core'
import { TrackJS } from 'trackjs'

const StyledFooter = styled.div([
  {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '0.8rem',
    marginTop: 20,
    color: 'gray',
  },
])

const releaseShortDesc = process.env.REACT_APP_COMMIT_SHA1
  ? `${process.env.REACT_APP_ENV}-${process.env.REACT_APP_COMMIT_SHA1.substr(0, 7)}`
  : 'unknown'

TrackJS.configure({ version: releaseShortDesc })

export const Footer = () => {
  return (
    <StyledFooter>
      <pre>Powered by J-Force • Build: {releaseShortDesc}</pre>
      <ClassNames>
        {({ css, cx }) => (
          <ToastContainer
            containerId="default"
            enableMultiContainer={true}
            autoClose={4000}
            hideProgressBar={true}
            position="bottom-center"
            closeButton={false}
            transition={Slide}
            toastClassName={css({
              background: '#1F2023',
              boxShadow: '0 0 10px 1px rgba(255,255,255,0.3)',
              marginBottom: -20,
              minHeight: 50,
              borderRadius: 4,
              color: 'white',
              fontSize: 14,
              fontWeight: 'bold',
              padding: '8px 25px',
            })}
          />
        )}
      </ClassNames>
      <ClassNames>
        {({ css, cx }) => (
          <ToastContainer
            containerId="error"
            enableMultiContainer={true}
            autoClose={4000}
            hideProgressBar={true}
            position="bottom-center"
            closeButton={false}
            transition={Slide}
            toastClassName={css({
              background: '#db2828',
              boxShadow: '0 0 10px 1px rgba(255,255,255,0.3)',
              marginBottom: -20,
              minHeight: 50,
              borderRadius: 4,
              color: 'white',
              fontSize: 14,
              fontWeight: 'bold',
              padding: '8px 25px',
            })}
          />
        )}
      </ClassNames>
    </StyledFooter>
  )
}
